import './Model1.css'
import Member1 from '../Assets/Member1.jpg';
import Member2 from '../Assets/Member2.jpg';
import Member3 from '../Assets/Member3.png';
import G from '../Assets/gp.jpeg';
import M from '../Assets/m2.png';
import N from '../Assets/n3.png';
import  GitHub  from '@mui/icons-material/GitHub';

export default function Model1() {
  return (
    <div id='model1'>
      <div className='founderFathers'>
      <h1 className='model-title'>გუნდი</h1>
      </div>
        <div className="divider"></div>
        <div className="members">
          <div className="member">
            <img width={400} height={400} src={G}/>
            <div className="description">
                <h1>გიორგი მეშველიანი</h1>
                <h2>CEO</h2>
                {/* <p>
                Consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet consectet.
                </p> */}
                <a href='https://github.com/George1Meshveliani' target="_blank">
                <div className="social-media">
                  <GitHub />
                </div>
                </a>
            </div>
          </div>
          <div className="member">
            <img width={400} src={M}/>
            <div className="description">
                <h1>მიხეილ პაპუნიძე</h1>
                <h2>CTO</h2>
                {/* <p>
                Consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet consectet.
                </p> */}
                <a href='https://github.com/MikheilPapundze' target="_blank">
                <div className="social-media">
                  <GitHub />
                </div>
                </a>

            </div>
          </div>
          <div className="member">
            <img width={400} src={N}/>
            <div className="description">
                <h1>ნიკა დუმბაძე</h1>
                <h2>CCO</h2>
                {/* <p>
                Consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat. Lorem ipsum dolor sit amet consectet.
                </p> */}
                <a href="https://github.com/NikaDumbo" target="_blank">
                <div className="social-media">
                  <GitHub />
                </div>
                </a>
            </div>
          </div>
        </div>
    </div>
  );
}
